module.exports = __webpack_public_path__ + "img/b38e464b4f7e00d7dfb54f244f75746c.8959b50f.png";